import React, { useState } from 'react';
import { ArrowLeftIcon, LockIcon } from 'lucide-react';
import type { AdminRole } from '../../types/config';
import { ADMIN_USERS } from '../../data/users';
import { MEDIA } from '../../data/media';
import { DmpLogo } from '../../components/brand/DmpLogo';
import { BdFlag } from '../../components/brand/BdFlag';
const ROLE_HINT: Partial<Record<AdminRole, string>> = {
  verifier: 'পরিস্থিতি ৪ — কাগজপত্র যাচাই',
  dealing: 'পরিস্থিতি ৪ — নোটশিট ও অগ্রায়ন',
  approver: 'পরিস্থিতি ৫ — নথি অনুমোদন',
  signatory: 'পরিস্থিতি ৫ — স্বাক্ষর ও পত্র ইস্যু'
};
export function AdminLogin({
  onLogin,
  onExit
}: {
  onLogin: (r: AdminRole) => void;
  onExit: () => void;
}) {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const match = (Object.keys(ADMIN_USERS) as AdminRole[]).find(r => ADMIN_USERS[r].staffId.toLowerCase() === id.trim().toLowerCase());
    if (!match) {
      setError('কর্মকর্তা আইডি পাওয়া যায়নি। নিচের ডেমো অ্যাকাউন্ট ব্যবহার করুন।');
      return;
    }
    if (!pw) {
      setError('পাসওয়ার্ড লিখুন।');
      return;
    }
    onLogin(match);
  };
  return <div className="grid min-h-full w-full lg:grid-cols-[1fr_560px] bg-canvas" data-id="element-814" data-mp="25oac7ta5q6wh">
      <div className="relative hidden lg:block" data-id="element-815" data-mp="2anel0it662ma">
        <img src={MEDIA.yard} alt="ডাম্পিং স্টেশনে সংরক্ষিত যানবাহন" className="absolute inset-0 h-full w-full object-cover" data-id="element-816" data-mp="2an4t2pokdldy" />
        <div className="absolute inset-0 bg-navy-950/75" data-id="element-817" data-mp="1cy1q5qci32cm" />
        <div className="relative flex h-full flex-col justify-between p-10 text-white" data-id="element-818" data-mp="1hzr4bev0rw4x">
          <div className="flex items-center gap-3" data-id="element-819" data-mp="1mx12biwh5g4d">
            <DmpLogo size={56} tone="light" data-id="element-820" data-mp="1mw937y3o509c" />
            <div data-id="element-821" data-mp="1rpu5w3g7iiev">
              <p className="text-lg font-bold" data-id="element-822" data-mp="1rqde2sg21sfp">ঢাকা মেট্রোপলিটন পুলিশ</p>
              <p className="text-sm text-white/75" data-id="element-823" data-mp="ua6j0pbe8msh">ট্রাফিক বিভাগ</p>
            </div>
          </div>
          <div data-id="element-824" data-mp="z7pwhn09ovjd">
            <h1 className="text-4xl font-bold leading-tight" data-id="element-825" data-mp="z76p3088tpjl">যানবাহন ডাম্পিং ও অবমুক্তকরণ ব্যবস্থাপনা সিস্টেম</h1>
            <p className="mt-3 max-w-lg text-white/80" data-id="element-826" data-mp="r5z2fcao5n7c">কেন্দ্রীয় কেস ব্যবস্থাপনা, কাগজপত্র যাচাই, ই-নথি ও বহুস্তর অনুমোদন, QR-যুক্ত অবমুক্তি পত্র ও প্রতিবেদন।</p>
          </div>
          <p className="text-xs text-white/60" data-id="element-827" data-mp="10wk0mymfkppq">প্রোটোটাইপ — নমুনা তথ্য ও সিমুলেটেড ইন্টিগ্রেশন</p>
        </div>
      </div>

      <div className="flex flex-col px-6 py-6 sm:px-10" data-id="element-828" data-mp="vzab7iz1ke1w">
        <div className="flex items-center justify-between" data-id="element-829" data-mp="885zia01pd9y">
          <button onClick={onExit} className="btn btn-ghost btn-sm" data-id="element-830" data-mp="8ar2j2c2xz9a"><ArrowLeftIcon className="h-4 w-4" data-id="element-831" data-mp="48npwadocomf" /> ডেমো হোম</button>
          <BdFlag width={30} data-id="element-832" data-mp="i6u1jzbmxhs0" />
        </div>
        <div className="my-auto py-8" data-id="element-833" data-mp="i8orjs1rk02y">
          <div className="lg:hidden mb-4" data-id="element-834" data-mp="d80r6frna6w2"><DmpLogo size={56} data-id="element-835" data-mp="d7r87c50ozzv" /></div>
          <h2 className="text-2xl font-bold text-ink" data-id="element-836" data-mp="d6pnsh24315h">ওয়েব অ্যাডমিন পোর্টাল</h2>
          <p className="text-sm text-ink-muted" data-id="element-837" data-mp="1tkz8n175a7rk">অনুমোদিত ডিএমপি কর্মকর্তাদের জন্য</p>
          <form onSubmit={submit} className="mt-6 space-y-4" noValidate data-id="element-838" data-mp="1om4itfarfixy">
            <div data-id="element-839" data-mp="36l2gtn6gtkpi"><label className="label" htmlFor="aid" data-id="element-840" data-mp="36kayhe1vpjh6">কর্মকর্তা আইডি</label><input id="aid" className="input font-mono" placeholder="যেমন: VRF-0745" value={id} onChange={e => setId(e.target.value)} data-id="element-841" data-mp="36mx43857lowr" /></div>
            <div data-id="element-842" data-mp="2xknxuugz4hp6"><label className="label" htmlFor="apw" data-id="element-843" data-mp="2xkw8sgtjdcxq">পাসওয়ার্ড</label><input id="apw" type="password" className="input" value={pw} onChange={e => setPw(e.target.value)} placeholder="ডেমো: যেকোনো পাসওয়ার্ড" data-id="element-844" data-mp="2xmh3c6fuovvl" /></div>
            {error && <p className="rounded-md bg-danger-50 px-3 py-2 text-xs text-danger-700" role="alert" data-id="element-845" data-mp="3q9blgwp73j5w">{error}</p>}
            <button type="submit" className="btn btn-primary btn-lg w-full" data-id="element-846" data-mp="3u9lqo755y5jp"><LockIcon className="h-4 w-4" data-id="element-847" data-mp="3gjrzvja3lb7c" /> লগইন</button>
          </form>

          <div className="mt-8" data-id="element-848" data-mp="3lhtki8n69ikx">
            <p className="mb-2 text-sm font-bold text-ink" data-id="element-849" data-mp="3lh1pp01efovp">ডেমো লগইন — ভূমিকা নির্বাচন</p>
            <ul className="divide-y divide-line rounded-xl border border-line bg-white" data-id="element-850" data-mp="d200hjtmtoz4">
              {(Object.keys(ADMIN_USERS) as AdminRole[]).map(r => <li key={r} data-id="element-851" data-mp="2pcjpsfxgh1wx">
                  <button onClick={() => onLogin(r)} className="flex w-full items-center justify-between gap-3 px-4 py-2.5 text-left hover:bg-navy-50" data-id="element-852" data-mp="2pcthq9229j59">
                    <span className="min-w-0" data-id="element-853" data-mp="2kfkz67d03d3h">
                      <span className="block text-sm font-semibold text-ink" data-id="element-854" data-mp="2gb3fs9ajz1t8">{ADMIN_USERS[r].title}</span>
                      <span className="block text-xs text-ink-muted" data-id="element-855" data-mp="2bdtt31ejt493">{ADMIN_USERS[r].name} · <span className="font-mono" data-id="element-856" data-mp="382t2wkus6e3e">{ADMIN_USERS[r].staffId}</span></span>
                    </span>
                    {ROLE_HINT[r] && <span className="shrink-0 rounded-full bg-bdgreen-50 px-2 py-0.5 text-[11px] font-semibold text-bdgreen-700" data-id="element-857" data-mp="342imee9d45aa">{ROLE_HINT[r]}</span>}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}